import { api, unwrapResponse } from './api';

export const deviceService = {
  getAll: () => api.get('/devices').then(unwrapResponse),
  getById: (id) => api.get(`/devices/${id}`).then(unwrapResponse),
  create: (payload) => api.post('/devices', payload).then(unwrapResponse),
  update: (id, payload) =>
    api.put(`/devices/${id}`, payload).then(unwrapResponse),
  delete: (id) => api.delete(`/devices/${id}`),
  /** Bulk upload tab: per-row results (created / skipped / error). */
  bulkImport: (devices) => api.post('/devices/bulk', { devices }, { silent: true }).then(unwrapResponse),
  verify: (deviceId) =>
    api
      .get(`/devices/mobile/verify?device_id=${encodeURIComponent(deviceId)}`)
      .then(unwrapResponse),
};
